import React from 'react';
import { ChevronRight } from 'lucide-react';

interface Props {
  title: string;
  count: number;
  hint?: string;
  open: boolean;
  onToggle: () => void;
  children: React.ReactNode;
  sectionRef?: React.Ref<HTMLElement>;
}

// A card whose body opens on demand: the deep-dive level of the summary.
export default function Disclosure({ title, count, hint, open, onToggle, children, sectionRef }: Props) {
  return (
    <section ref={sectionRef} className="overflow-hidden rounded-2xl bg-white shadow-sm ring-1 ring-gray-200/70 contrast-more:ring-gray-400">
      <button
        type="button"
        onClick={onToggle}
        aria-expanded={open}
        className="flex w-full items-center gap-3 px-4 py-3.5 text-left transition-colors duration-150 hover:bg-gray-50/70 active:bg-gray-100/70 motion-reduce:transition-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-blue-500"
      >
        <ChevronRight
          className={`h-4 w-4 shrink-0 text-gray-500 transition-transform duration-200 ease-out motion-reduce:transition-none ${open ? 'rotate-90' : ''}`}
          aria-hidden
        />
        <span className="text-sm font-semibold text-gray-900">{title}</span>
        <span className="rounded-full bg-gray-100 px-2 py-0.5 text-[0.6875rem] font-semibold tabular-nums text-gray-600">{count}</span>
        {hint && <span className="ml-auto truncate text-xs text-gray-500">{hint}</span>}
      </button>
      {open && <div className="border-t border-gray-100 motion-safe:animate-[fadeIn_0.18s_ease-out]">{children}</div>}
    </section>
  );
}
